 


window.addEventListener("DOMContentLoaded",()=>{

 
    const allCustomProductItems= document.querySelectorAll(".CustomProductItem");
    
        allCustomProductItems.forEach(CustomProductItem=>{
            const quickAtcToggleWrapper=CustomProductItem.querySelector(".custom_new_quick_atc_toggle_wrapper");

            if(quickAtcToggleWrapper){

                    CustomProductItem.addEventListener("mouseenter",()=>{
                        if( window.innerWidth >=992){
                            CustomProductItem.classList.add("active-product-item")
                            quickAtcToggleWrapper.setAttribute("data-toggle","-")
                        }
                        
                        
                        })
                        
                    CustomProductItem.addEventListener("mouseleave",()=>{
                        if(window.innerWidth >=992){
                            
                        CustomProductItem.classList.remove("active-product-item")
                        quickAtcToggleWrapper.setAttribute("data-toggle","+")
                        }
                            
                        })
                
               /* else{

                    if(document.body.getAttribute('data-quick-add-test') =="a"){

                        CustomProductItem.querySelector('.custom_new_quick_atc_toggle_wrapper').addEventListener("click",()=>{
                           
                            if(!CustomProductItem.classList.contains('active-product-item')){
                                CustomProductItem.classList.add("active-product-item")
                                quickAtcToggleWrapper.setAttribute("data-toggle","-")
                            }
                            else{  

                                CustomProductItem.classList.remove("active-product-item")
                                quickAtcToggleWrapper.setAttribute("data-toggle","+")

                            }

                                
                                })



                    }
                    else if (document.body.getAttribute('data-quick-add-test') =="b"){
                        if( CustomProductItem.querySelector('.quick__add_wrapper')){

                            CustomProductItem.querySelector('.quick__add_wrapper').addEventListener("click",()=>{

                                CustomProductItem.classList.toggle("active-product-item")
                            
                            
                            })
                        }
                       

                    }

                }*/

               
        
            }
                
    
        })
})

